import lodashCloneDeep from 'lodash/cloneDeep'

export const setDirectoryContentTargetItemIndexActionType = 'setDirectoryContentTargetItemIndexActionType';

export function setDirectoryContentTargetItemIndexAction(targetItemIndex) {
    return {
        type: setDirectoryContentTargetItemIndexActionType,
        payload: {
            targetItemIndex: targetItemIndex,
        }
    }
}

export function setDirectoryContentTargetItemIndexHandler(state, action) {
    const { targetItemIndex } = action.payload;
    let newState = lodashCloneDeep(state);

    newState.directoryContentTargetItemIndexes = newState.directoryContentTargetItemIndexes.set(newState.selectedFileSystemNodePath.join('/'), targetItemIndex);

    return newState;
}
